import React from 'react';

export const HOTexts = {
  title: {
      ko: (<>Anti-Ransomware Solution</>),
      en: (<>Anti-Ransomware Solution</>)
  },
  subtitle: {
      ko: (<>Halcyon</>),
      en: (<>Halcyon</>)
  }
};

export const outlineTexts = {
  title: {
    ko: (<>Ransomware 해킹을 정면 돌파, 2~3분내에 복원하는 독보적 Solution!</>),
    en: (<>Ransomware hacking breakthrough with a unique solution restoring within 2-3 minutes!</>)
  },
  container: {
    title:{
      ko: (<>Halcyon 4가지 특장점</>),
      en: (<>Halcyon 4 Key Features</>)
    },
    encryptkey: {
      title:{
        ko: (<>Ransomware 감염 데이터 정상화 기술</>),
        en: (<>Ransomware Infection Data Normalization Technology</>)
      },
      text:{
        t1:{
          ko: (<>해커의 Ransomware 암호화 Key 가로채는 기능</>),
          en: (<>Function to intercept hacker's Ransomware encryption key</>)
        },
        t2:{
          ko: (<>가로챈 Key로 2~3분 이내 복호화 기능</>),
          en: (<>Decryption function within 2-3 minutes using the intercepted key</>)
        },
        t3:{
          ko: (<>별도의 백업 데이터 없이 데이터 직접 복원 기능</>),
          en: (<>Direct data restoration function without separate backup data</>)
        },
        t4:{
          ko: (<>Ransomware에 감염된 데이터 100% 원상 복원</>),
          en: (<>100% restoration of data infected by Ransomware</>)
        },
      }
    },
    engine: {
      title:{
        ko: (<>Ransomware 방어에 최적화된 엔진</>),
        en: (<>Ransomware Defense Optimized Engine</>)
      },
      text:{
        t1:{
          ko: (<>Ransomware 공격 패턴을 시그니처 기반이 아닌 비 정형 행위 차원에서 인지하는 기술</>),
          en: (<>Ransomware attack pattern recognition technology based on unstructured behavior rather than signature</>)
        },
        t2:{
          ko: (<>EDR/백신 등 엔드포인트에서 감지하지 못한 Ransomware 대응 기능</>),
          en: (<>EDR/Antivirus Endpoint Detection Capabilities</>)
        },
        t3:{
          ko: (<>클라우드 AI 엔진으로 변종 Ransomware 파악 기능</>),
          en: (<>Cloud AI Engine for Identifying Variant Ransomware</>)
        },
        t4:{
          ko: (<>파일·메모리·커널 등 복합적 다 계층을 총합적 보호</>),
          en: (<>Comprehensive protection across multiple layers including files, memory, and kernel</>)
        },
      }
    },
    independence: {
      title:{
        ko: (<>독립적, 자동적 Agent 프로세스 가동</>),
        en: (<>Independent, Automatic Agent Process Operation</>)
      },
      text:{
        t1:{
          ko: (<>네트워크와 무관하게 동작하는 엔드포인트 기반</>),
          en: (<>Endpoint-based operation independent of the network</>)
        },
        t2:{
          ko: (<>네트워크가 차단된 상황에서도 보호, 복구 완료</>),
          en: (<>Protection and recovery completed even when the network is disconnected</>)
        },
      }

    },
    environment: {
      title:{
        ko: (<>효율적 업무 환경 유지</>),
        en: (<>Efficient Work Environment Maintenance</>)
      },
      text:{
        t1:{
          ko: (<>Halcyon Agent 설치로 즉시 Ransomware 위험 상시 감지</>),
          en: (<>Halcyon Agent installation for immediate and continuous Ransomware risk detection</>)
        },
        t2:{
          ko: (<>경량화 Agent로 IT 자산 리소스 최소 사용</>),
          en: (<>Minimal IT asset resource usage with lightweight Agent</>)
        },
        t3:{
          ko: (<>자동화된 능동적 운영 정책 실행</>),
          en: (<>Automated Active Operation Policy Execution</>)
        },
        t4:{
          ko: (<>EDR/XDR/EPP 연동 가능</>),
          en: (<>Integration with EDR/XDR/EPP</>)
        },
        t5:{
          ko: (<>SIEM 솔루션 이벤트 제공</>),
          en: (<>SIEM solution event provision</>)
        },
      }

    }
  }
};

export const movementTexts = {
  title: {
    ko: (<>Halcyon 동작 방법</>),
    en: (<>Halcyon Operation Method</>)
  },
  content: {
    detection: {
      ko: (<>실시간 탐지</>),
      en: (<>Real-time Detection</>)
    },
    protection: {
      ko: (<>통합 보호</>),
      en: (<>Integrated Protection</>)
    },
    response: {
      ko: (<>신속 대응</>),
      en: (<>Rapid Response</>)
    }
  }
};

export const attackTexts = {
  title: {
      ko: (<>다양한 수단과 방법으로 접근 하는 Ransomware 에 대한 맞춤형 방어 체계</>),
      en: (<>Customized Defense System Against Various Means and Methods of Ransomware</>),
  },
  initialaccess: {
    title: {
      ko: (<>초기 접근</>),
      en: (<>Initial Access</>)
    },
    message: {
      ko: (<>Halcyon은 공격자가 악성 실행 파일, 무차별 대입공격 시도 또는 명령 및 제어(C2) 
           인프라를 악용하여 사용자 환경에 엑세스하는 경우를 감지</>),
      en: (<>Halcyon detects when attackers use malicious executables, brute-force attack attempts, 
           or command and control (C2) infrastructure to gain access to user environments.</>)
    },
  },
  remoteaccess: {
    title: {
      ko: (<>원격 접근</>),
      en: (<>Remote Access</>)
    },
    message: {
      ko: (<>초기 접근 권한을 획득한 후, 해커는 원격 접근 도구를 악용하여 공격을 시도할 때,
           Halcyon은 이러한 공격 시도를 즉시 감지하고 경고 알람 작동</>),
      en: (<>After gaining initial access, attackers typically use remote access tools to carry out their attacks more effectively.
           Halcyon detects these activities and generates alerts for immediate investigation.</>)
    },
  },
  privilege: {
    title: {
      ko: (<>권한 상승</>),
      en: (<>Privilege Escalation</>)
    },
    message: {
      ko: (<>Halcyon은 악성 실행 파일이나 취약한 커널 드라이버를 악용하여 
           사용자 권한을 확대하려는 해커의 시도를 즉시 경고하고 방어</>),
      en: (<>Halcyon warns and interferes with attempts by attackers to escalate 
           user privileges using malicious executables or vulnerable kernel drivers.</>)
    },
  },
  environmentenumeration: {
    title: {
      ko: (<>환경 열거</>),
      en: (<>Environment Enumeration</>)
    },
    message: {
      ko: (<>Halcyon은 해커가 정찰 및 사전 정보 수집을 위해 사용자의 IT 환경을 접근 시도 할 때, 
           이를 초기에 감지, 분석 및 판단</>),
      en: (<>Halcyon identifies when attackers attempt to enumerate user environments for reconnaissance and 
           information gathering, ultimately making attacks more effective.</>)
    },
  },
  credentialharvesting: {
    title: {
      ko: (<>자격 증명 수집</>),
      en: (<>Credential Harvesting</>)
    },
    message: {
      ko: (<>Halcyon은 해커가 유효한 사용자 자격 증명을 수집하는 방법을 감지하고,
           해커의 행위를 자동 탐지 차단</>),
      en: (<>Halcyon understands how attackers collect valid user credentials and 
           automatically detects and blocks their actions.</>)
    },
  },
  lateralmovement: {
    title: {
      ko: (<>측면 이동</>),
      en: (<>Lateral Movement</>)
    },
    message: {
      ko: (<>Halcyon은 해커가 사용자 환경 내에서 우회 이동을 시도할 때 이를 감지하고 차단,
           예: RMM도구를 사용하여 IT 환경의 시스템에 접속을 시도할 때, Halcyon은 이를 즉시 차단</>),
      en: (<>Halcyon detects and blocks attempts by attackers to move laterally within user environments.
           For example, if an attacker tries to access systems within the environment using RMM tools, Halcyon can block that activity.</>)
    },
  },
  securitybypass: {
    title: {
      ko: (<>보안 우회</>),
      en: (<>Security Bypass</>)
    },
    message: {
      ko: (<>해커가 EDR의 내제된 고유의 기능을 사용하여 
           실시간으로 기존 IT 보안 솔루션을 우회 또는 비 활성화하려는 시도를 차단</>),
      en: (<>Halcyon uses unique features such as EDR Last Gasp and Tamper Guard to block attempts by attackers
           to bypass and disable security products in real-time.</>)
    },
  },
  dataexfiltration: {
    title: {
      ko: (<>데이터 유출</>),
      en: (<>Data Exfiltration</>)
    },
    message: {
      ko: (<>Halcyon의 데이터 유출 방지(DXP) 기능은 하나의 시스템적으로 작동하여  다른 일반적 보안 도구나 솔루션으로는
           감지하기 매우 어려운 해커의 데이터 탈취시도를 조기 경고</>),
      en: (<>Halcyon Data Exfiltration Prevention (DXP) serves as a system 
           that provides early warnings of attempts by attackers to steal data 
           that have not yet been detected by other security tools.</>)
    },
  },
  backupdestruction: {
    title: {
      ko: (<>백업 파괴</>),
      en: (<>Backup Destruction</>)
    },
    message: {
      ko: (<>Halcyon은 악성 실행 파일, 무차별 대입 공격, 명령 및 제어(C2) 인프라 등을 사용하여
           사용자 환경에  처음 접근을 시도하는 해커의 이상행위를 감지하고, 이를 억지,방해</>),
      en: (<>Halcyon can detect and thwart attackers attempting to gain initial access to user environments using
           malicious executables, brute-force attacks, or command and control (C2) infrastructure.</>)
    },
  },
  dataencryption: {
    title: {
      ko: (<>데이터 암호화</>),
      en: (<>Data Encryption</>)
    },
    message: {
      ko: (<>Halcyon은 Ransomware 공격으로 data가 강제 암호화 되는 경우  해커의 Ransomware Key를 직접 가로채어
           Ransomware 암호를 해독 (decrypt)하고 data를 원상 복원하기 위한 대체 경로 제공</>),
      en: (<>Halcyon provides an alternative recovery path in the event 
           that data is encrypted during a ransomware attack by utilizing captured key material to decrypt the data.</>)
    },
  },

};

export const platformTexts = {
  title: {
      ko: (<>다양한 OS 종류 지원</>),
      en: (<>Various OS Support</>),
  },
};

export const customerTexts = {
  title: {
      ko: (<>Halcyon 고객</>),
      en: (<>Halcyon Customers</>),
  }
};

export const prizeTexts = {
  title: {
      ko: (<>글로벌 최고 권위 기관으로부터 인정 받은 Halcyon</>),
      en: (<>Global Recognition from Prestigious Institutions for Halcyon</>),
  },
  group: {
    crn_ai100: {
      ko: (<>2024 CRN AI 100</>),
      en: (<>2024 CRN AI 100</>)
    },
    globalinforsecawards: {
      ko: (<>2025 글로벌 인포섹<br/>어워드 이중 수상</>),
      en: (<>2025 Global Infosec<br/>Award Double Winner</>)
    },
    cybersecurity: {
      ko: (<>센디에이고 비즈니스 저널<br/>사이버보안 관리상 2025</>),
      en: (<>2025 San Diego Business Journal<br/>Cybersecurity Management Award</>)
    },
    scawards: {
      ko: (<>2025 SC 어워드 수상<br/>최고 엔터프라이즈 보안 솔루션</>),
      en: (<>2025 SC Award Winner<br/>Best Enterprise Security Solution</>)
    },
    crn_winner: {
      ko: (<>2025 SC 어워드 수상<br/>최고 엔터프라이즈 보안 솔루션</>),
      en: (<>2025 SC Award Winner<br/>Best Enterprise Security Solution</>)
    },
    forbes: {
      ko: (<>포브스 2024<br/>미국 최고 스타트업 고용주</>),
      en: (<>Forbes 2024<br/>Best Startup Employers in the USA</>)
    },
    theinformation: {
      ko: (<>The Information<br/>2023 가장 유망 스타트업</>),
      en: (<>The Information<br/>2023 Most Promising Startup</>)
    },
    fortune: {
      ko: (<>Fortune 연간 Cyber60 목록<br/>Early Stage 카테고리 선정 2023</>),
      en: (<>Fortune Annual Cyber60 List<br/>Early Stage Category Selection 2023</>)
    },
    cyberdefense: {
      ko: (<>Cyber Defense Magazine 2023<br/>최고 정보 보안 혁신과<br/>최첨단 사이버 복원력 부문 수상</>),
      en: (<>Cyber Defense Magazine 2023<br/>Best Information Security Innovation<br/>Cutting-edge, and Cyber Resilience Award</>)
    },
    enterprisesecurity: {
      ko: (<>Enterprise Security Tech<br/>2023 Cyber Top 20 수상</>),
      en: (<>Enterprise Security Tech<br/>2023 Cyber Top 20 Award</>)
    },
    fc_bigthings: {
      ko: (<>Fast Company<br/>2023 신기술 목록</>),
      en: (<>Fast Company<br/>2023 Innovation List</>)
    },
    fc_innovative: {
      ko: (<>Fast Company<br/>2024 혁신적 기업</>),
      en: (<>Fast Company<br/>2024 Innovative Company</>)
    },
  },

};


